import _ from 'lodash';

/**
 * @name collectorWantsNotif
 * @description Function to check to see if a collector wants a notification
 * @param {type} Association The Association service
 * @param {type} ArtistNotificationPrefs The ArtistNotificationPrefs service
 * @param {type} OperatorNotificationPrefs The OperatorNotificationPrefs service
 * @return {service} Returns the service
 */
function collectorWantsNotif(
  Association,
  ArtistNotificationPrefs,
  OperatorNotificationPrefs
) {
  // Public methods
  collectorWantsNotif.check = check;

  /**
   * @name check
   * @description Function to check if the username is available
   * @param {number} collectorId The collector to check the notification
   * @param {number} shopId The shop to find the correct association
   * @param {number} notificationPref The name of the notification pref to check
   * @param {number} notifType The type of notification to check. Can be either
   * 'artist', 'operator', or 'collector'
   * @return {boolean} Returns the answer
   */
  function check(collectorId, shopId, notificationPref, notifType) {
    /**
     * @name getAssociation
     * @description Function to get a collector association
     * @param {number} collectorId Description
     * @return {boolean} Returns a boolean value
     */
    function getAssociation(collectorId) {
      return Association.getAssociation(collectorId)
      .then(function(associations) {
        let artistAssociation =
        _.find(associations.artists.confirmed, function(el) {
          if (shopId === el.shop.id) {
            return true;
          }
        });
        return artistAssociation;
      });
    }

    /**
     * @name getNotifPrefs
     * @description description
     * @param {type} artistAssociation Description
     * @return {boolean} Returns a boolean value
     */
    function getNotifPrefs(artistAssociation) {
      if (notifType === 'artist') {
        return ArtistNotificationPrefs
        .get(artistAssociation.artistNotificationPreference)
        .then(function(prefs) {
          return prefs;
        });
      } else if (notifType === 'operator') {
        return OperatorNotificationPrefs
        .get(artistAssociation.operatorNotificationPreference)
        .then(function(prefs) {
          return prefs;
        });
      }
    }

    /**
     * @name findNotif
     * @description description
     * @param {object} prefs The notification prefs
     * @return {boolean} Returns a boolean value
     */
    function findNotif(prefs) {
      return prefs[notificationPref];
    }

    return getAssociation(collectorId)
    .then(getNotifPrefs)
    .then(findNotif);

    // Add a catch statement above to bubble up errors
  }
  return collectorWantsNotif;
}

angular
  .module('inkfinder')
  .factory('collectorWantsNotif', collectorWantsNotif);



// WEBPACK FOOTER //
// ./components/collector/notification-prefs/collector-wants-notif.service.js